module.exports = __webpack_public_path__ + "static/media/Anna.3b41a62b.png";